import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Page404 from "./../Pages/Page404/Page404";
import LandingPage from "./landingpage/LandingPage";
import EventSeatsPage from "./eventpage/EventSeatsPage";
import CookiePolicyPage from "./cookiepage/CookiePolicyPage";
import Loader from "./../../commons/loader";
import TimeoutPage from "./timeoutpage/TimeoutPage";
import KioskPage from "./kiosk/KioskPage";
import IdopontPage from "./idopont/IdopontPage";
import AktivalPage from "./idopont/AktivalPage";
import Adatvedelmi from "./adatvedelmi/Adatvedelmi";
import { LoadingProvider } from './LoadingContext';
import LoadingScreen from './LoadingScreen';
import Aszf from "./aszf/Aszf";
import { CookieConsentProvider } from './../../commons/CookieConsent';
import NotFound from "./eventpage/NotFound";

export default class PublicRoutes extends React.Component {

 // static contextType = LoadingContext;

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      layout: null,
      event: null,
      init: null,
      isPortalReady: false,
      excepts: ['/kiosk', '/idopont'],
    };
    console.log('contex', context)
  }

  componentWillMount() {
    if (document.querySelector("[name='description']")) {
      document.querySelector("[name='description']").remove();
    }
    if (document.querySelector("[name='title']")) {
      document.querySelector("[name='title']").remove();
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    //this.context.hideLoading();
    console.log('cType', this.context, this.props)
  }

  changePortalData = (layout, init, event) => {
    this.setState({
      layout,
      init,
      event
    }, () =>
      this.setState({
        isPortalReady: true
      })
    )
  }

  dismissPortal = () => {
    this.setState({
      isPortalReady: false
    })
  }

  exceptUrlCheck = (globals) => {
    return this.state.excepts.filter((except) => { return window.location.pathname.startsWith(globals.public_url + except) }).length === 0;
  }

  render() {
    const globals = this.props.globals;
    // console.log('GLOB', globals)
    return (
      <React.Fragment>
        {(this.exceptUrlCheck(globals)) ?
          !this.state.loading ? ''
            :
            <React.Fragment>
              <CookieConsentProvider>
                <LoadingProvider>
                  <LoadingScreen />
                  <React.Fragment>
                    <Helmet link={[{ rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "stylePub.css" }, { rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "App.css" }, { rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "mainPub.css" }]} >
                      <meta name="title" content="organw" />
                      <meta name="description" content="organw" />
                    </Helmet>
                    <Header globals={globals} layout={this.state.layout} init={this.state.init} event={this.state.event} isPortalReady={this.state.isPortalReady} />
                    <div id="page-content" className="page-content" />
                    <Routes>
                      <Route index element={<LandingPage />} />
                      <Route path={`event/:eventId`}
                        element={<EventSeatsPage globals={globals} />}
                      />
                      <Route path={`cookie-policy`}
                        element={<CookiePolicyPage globals={globals} />}
                      />
                      <Route path={`timeout`} element={<TimeoutPage globals={globals} />} />
                      <Route path={`about`} element={<About />} />
                      <Route path={`topics`} element={<Topics />} />
                      {/* Ha kialakultak a statikus oldalak, akkor visszarakható */}
                      {/* <Route path={`${props.globals.public_url}/adatvedelmi`} element={<Adatvedelmi />} />
                <Route path={`${props.globals.public_url}/aszf`} element={<Aszf />} /> */}
                      <Route path={`*`} name="404" element={<NotFound globals={globals}/>} />
                    </Routes>
                    <Footer globals={globals} />
                  </React.Fragment>
                </LoadingProvider>
              </CookieConsentProvider>
            </React.Fragment>
          :
          <div>
            <Helmet link={[{ rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "stylePub.css" }, { rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "App.css" }, { rel: "stylesheet", type: "text/css", href: globals.public_url + '/css/' + "mainPub.css" }]} >
              <meta name="title" content="organw" />
              <meta name="description" content="organw" />
            </Helmet>
            <Header globals={globals} layout={this.state.layout} init={this.state.init} event={this.state.event} isPortalReady={this.state.isPortalReady} />
            <Routes>
              <Route path={`${globals.public_url}/kiosk/:eszkozazonosito`} element={<KioskPage globals={globals} />} />
              <Route path={`${globals.public_url}/idopont/aktival`} element={<AktivalPage globals={globals} />} />
              <Route path={`${globals.public_url}/idopont`} element={<IdopontPage globals={globals} />} />
            </Routes>
            <Footer globals={globals} />
          </div>
        }
      </React.Fragment>
    );
  }
}

function About() {
  return <Loader style={{ marginTop: 60 }} />;
}

function Topic({ match }) {
  return <h3>Requested Param: {match.params.id}</h3>;
}

function Topics({ match }) {
  return (
    <div>
      <h2>Topics</h2>

      <ul>
        <li>
          <Link to={`${match.url}/components`}>Components</Link>
        </li>
        <li>
          <Link to={`${match.url}/props-v-state`}>Props v. State</Link>
        </li>
      </ul>

      <Route path={`${match.path}/:id`} element={<Topic />} />
      <Route
        exact
        path={match.path}
        element={<h3>Please select a topic.</h3>}
      />
    </div>
  );
}

// function Header() {
//   return (
//     <ul>
//       <li>
//         <Link to="/">Home</Link>
//       </li>
//       <li>
//         <Link to="/about">About</Link>
//       </li>
//       <li>
//         <Link to="/topics">Topics</Link>
//       </li>
//     </ul>
//   );
// }